<template>
	<div class="contact-search">
		<template v-if="selectedContact.id === null">
			<div class="form-group">
				<label for="search">
					Contact
					<span
						role="button"
						:title="'You can search name and state separated with comma, example:black river,wi'"
					>
						ℹ️
					</span>
				</label>
				<input
					type="text"
					class="form-control"
					v-model="search"
					placeholder="type email to search for contact"
				/>
			</div>
			<div class="search-results-container position-relative">
				<div class="search-results position-absolute bg-white rounded shadow-sm" style="z-index:999">
					<template v-if="!loading">
						<template v-if="contacts.length > 0">
							<template v-for="contact in contacts">
								<div
									:key="contact.id"
									@click="setContact(contact)"
									class="search-item ps-2 pe-2 py-1 d-flex justify-content-between"
								>
									<span class="me-2">{{ contact.first_name }} {{ contact.last_name }}</span>
									<span class="pe-2">{{ contact.email }}</span>
								</div>
							</template>
						</template>
						<template v-if="contacts.length === 0 && search.length > 3">
							<span class="me-2 ms-2">Contact not found!</span>
						</template>
					</template>
					<template v-else>
						<div class="d-flex justify-content-center p-2">
							<div class="spinner-border spinner-border-sm" role="status">
								<span class="sr-only">Loading...</span>
							</div>
						</div>
					</template>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="form-group">
				<label for="contact">Contact</label>
				<div class="d-flex">
					<h5>{{ selectedContact.first_name }} {{ selectedContact.last_name }}</h5>
					<a href="#" @click="changeContact()" class="ms-3">change</a>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import restApi from '../../api/index'
import { handleErrors } from '../../actions/helpers'
export default {
	name: 'ContactSearch',
	//props: ['user'],
	data() {
		return {
			loading: false,
			contacts: [],
			search: '',
			contactId: null,
			selectedContact: {
				id: null,
				first_name: '',
				last_name: '',
			},
		}
	},
	created() {},
	computed: {
		...mapState(['storageUrl']),
	},
	methods: {
		getContacts() {
			this.loading = true
			this.params = {
				search: this.search,
			}
			restApi
				.get(`/contacts/search`, { params: this.params })
				.then(({ data }) => {
					this.contacts = data
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		setContact(contact) {
			this.selectedContact.id = contact.id
			this.selectedContact.first_name = contact.first_name
			this.selectedContact.last_name = contact.last_name
			this.contacts = []
			this.search = ''
			this.$emit('setContact', contact)
		},
		changeContact() {
			this.selectedContact = {
				id: null,
				first_name: '',
				last_name: '',
			}
			this.$emit('setContact', null)
		},
	},
	watch: {
		search: function() {
			if (this.search.length >= 2) {
				if (!this.loading) {
					this.getContacts()
				}
			} else {
				this.contacts = []
			}
		},
	},
}
</script>

<style lang="scss">
.search-results-container {
	.search-results {
		width: 100%;
		.search-item {
			cursor: pointer;
			&:hover {
				background-color: whitesmoke;
				border-radius: 0.5rem;
			}
		}
	}
}
</style>
